export default __webpack_public_path__ + "static/IgGlbRQQ-470564710fb5ee213eeaffa217079ede.svg";